<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 16C12 15.4477 12.4477 15 13 15H16V5H13C12.4477 5 12 4.55229 12 4C12 3.44771 12.4477 3 13 3L17 3C17.5523 3 18 3.44771 18 4V16C18 16.5523 17.5523 17 17 17H13C12.4477 17 12 16.5523 12 16ZM6.29289 15.7071C5.90237 15.3166 5.90237 14.6834 6.29289 14.2929L9.58579 11L2 11C1.44772 11 1 10.5523 1 10C1 9.44771 1.44772 9 2 9L9.58579 9L6.29289 5.70711C5.90237 5.31658 5.90237 4.68342 6.29289 4.29289C6.68342 3.90237 7.31658 3.90237 7.70711 4.29289L12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071L7.70711 15.7071C7.31658 16.0976 6.68342 16.0976 6.29289 15.7071Z"
      fill="#28646E"
    />
  </svg>
</template>
<script>
export default {
  name: 'sign-in',
};
</script>
